import { Controller } from '@hotwired/stimulus'
import { sharedRadialColorPicker } from '../lib/shared_radial_color_picker'

export default class extends Controller {
  static targets = ['input', 'trigger', 'text']

  connect () {
    this.paint()
  }

  open (event) {
    event.preventDefault()
    event.stopPropagation()
    sharedRadialColorPicker.openFor(this)
  }

  textChanged () {
    if (!this.hasTextTarget) return

    const value = this.normalizeHex(this.textTarget.value)
    if (!value) return

    this.setValue(value, { emit: true })
  }

  get anchorElement () {
    if (this.hasTriggerTarget) return this.triggerTarget
    if (this.hasTextTarget) return this.textTarget
    return this.inputTarget
  }

  get hostElement () {
    return this.element.closest("[data-controller='mct']") || document.body
  }

  get value () {
    return this.inputTarget.value || '#FF0000'
  }

  setValue (value, options = {}) {
    const normalized = this.normalizeHex(value)
    if (!normalized) return

    this.inputTarget.value = normalized

    if (this.hasTextTarget) {
      this.textTarget.value = normalized
    }

    this.paint()

    if (options.emitInput) {
      this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
    }

    if (options.emitChange) {
      this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  paint () {
    if (!this.hasTriggerTarget) return
    this.triggerTarget.style.background = this.normalizeHex(this.value) || '#FF0000'
  }

  normalizeHex (value) {
    if (!value) return null

    const hex = value.trim()
    if (!/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(hex)) return null

    if (hex.length === 4) {
      return `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`.toUpperCase()
    }

    return hex.toUpperCase()
  }
}
